/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formname_Label1Inputs */

const ja_contact_formname_label1 = /** @type {(inputs: Contact_Formname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お名前`)
};

const en_contact_formname_label1 = /** @type {(inputs: Contact_Formname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Name`)
};

/**
* | output |
* | --- |
* | "Your Name" |
*
* @param {Contact_Formname_Label1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formname_label1 = /** @type {((inputs?: Contact_Formname_Label1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formname_Label1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formname_label1(inputs)
	return en_contact_formname_label1(inputs)
});
export { contact_formname_label1 as "contact_formName_label" }